<template>
  <div v-if="showModal">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <div class="modal-title">
                  <button type="button" class="close" @click="closeModal">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12 logo-section">
                    <!--Image-->
                    <div class="logo">
                      <img src="assets/logo/logo_dark.png" alt="Winfin">
                      <h4>Get Started with Winfin</h4>
                    </div>
                    <!--Image-->
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <h3 class="welcome">Sign In</h3>
                    <!--LOGIN FORM START-->
                    <form @submit.prevent="login" name="form1" class="login-form">
                      <div class="form-group">
                        <label for="email">Email</label>
                        <p class="control has-icon has-icon-right">
                          <input name="email" id="email" v-model="email" v-validate.persist="'required'" :class="{'input': true, 'is-danger': errors.has('email') }" class="form-control" type="text" placeholder="Email">
                          <i v-show="errors.has('email')" class="fa fa-warning"></i>
                          <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
                        </p>
                      </div>
                      <div class="form-group">
                        <label for="password">Password</label>
                        <p class="control has-icon has-icon-right">
                          <input name="password" id="password" v-model="password" v-validate.persist="'required'" :class="{'input': true, 'is-danger': errors.has('password') }" class="form-control" type="password" placeholder="Password">
                          <i v-show="errors.has('password')" class="fa fa-warning"></i>
                          <span v-show="errors.has('password')" class="help is-danger">{{ errors.first('password') }}</span>
                        </p>
                      </div>
                      <div class="form-group">
<!--                        <p class="forgot-section"><a href="javascript:">Forgot Password</a></p>-->
                        <button type="submit" class="btn btn-dark login-button">Sign In</button>
                      </div>
                      <div class="guest">
                        <h3>OR</h3>
                        <button type="button" class="btn btn-dark guest-button" @click="guestLogin">Continue as Guest</button>
                      </div>
                      <div class="form-group" style="padding: 10px 0;">
                        <a href="javascript:" class="register-button" @click="showRegister">Don't have an account? <b>Sign Up Now</b></a>
                        <a href="javascript:" class="forgot-button" @click="showForgot"><b>Forgot Password?</b></a>
                      </div>
                    </form>
                    <!--LOGIN FORM END-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios"
export default {
  name: "LoginModal",
  data() {
    return {
      // loginShow: true,
      // regShow: false,
      email: '',
      password: '',
    }
  },
  computed: {
    showModal() {
      return this.$store.state.showModal;
    }
  },
  methods: {
    closeModal() {
      this.$store.commit('showModal',false);
    },
    showRegister() {
      this.closeModal();
      this.$store.commit('showRegModal',true);
    },
    showForgot() {
      this.closeModal();
      this.$store.commit('showForgotModal',true);
    },
    login(e) {
      e.preventDefault();
      this.$validator.validateAll().then((result) => {
        if (result) {
          let instance = this;
          axios.get(`${this.apiPath}client-login?email=${this.email}&password=${this.password}`).then(function (response){
            if (response.data.status === "success") {
              instance.$toaster.success(response.data.message);
              instance.$store.commit('showModal',false);
              instance.$store.commit('loginStatus',true);
              instance.$store.dispatch('setUser',response.data.user);
              localStorage.setItem('access_token',response.data.token);
              localStorage.setItem('email',instance.email);
              instance.email = '';
              instance.password = '';
            } else if(response.data.status === "portal") {
              console.log(response.data);
              window.location.href = `${instance.loginUrl}login?tk=${response.data.token}`;
            }
          }.bind()).catch(function (error){
            instance.$toaster.error(error.response.data.message);
          });
        }
      });
    },
    guestLogin()
    {
      this.closeModal();
      this.$store.commit('showGuestModal',true);
    },
  },
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-dialog {
  max-width: 1000px !important;
}
.modal-header {
  border: none !important;
}
.modal-body {
  padding: 0 30px;
}
.login-form {
  margin-bottom: 50px;
}
.login-button {
  width: 100%;
  background: #004a59;
  border: 1px solid #004a59;
}
.guest-button {
  width: 100%;
  background: #8f2d56;
  border: 1px solid #8f2d56;
}
.register-button {
  color: #004a59;
  width: 100%;
  margin-bottom: 50px;
  font-size: 14px;
}
.forgot-button {
  color: #004a59;
  margin-bottom: 50px;
  font-size: 14px;
  float: right;
}
.forgot-section {
  float: right;
  margin-bottom: 5px;
  font-weight: bold;
}
.forgot-section a {
  color: #004a59;
  letter-spacing: 0.05em;
  font-weight: bold;
}
.forgot-section a:hover {
  color: #004a59;
}
.welcome {
  text-align: left;
  font-weight: bold;
  color: #004a59;
}
.modal-header {
  display: block;
}
.error p,ul > li {
  color: #ee3434;
  margin-left: -22px;
  line-height: 20px;
}
.error ul {
  margin-bottom: 0px;
}
.form-group {
  margin-bottom: 0.4rem;
}
.form-group label {
  margin-bottom: 0.1rem;
}
.is-danger {
  color: #ee3434;
}
.control {
  margin-bottom: 0;
}
.logo {
  padding: 40px 80px;
}
.logo h4 {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 18px;
  margin-top: 30px;
}
.logo img {
  width: 215px;
}
.guest h3 {
  text-align: center;
  color: #004a59;
}
@media (max-width: 767px) {
  .logo-section {
    display: none;
  }
  .forgot-button {
    color: #004a59;
    margin-bottom: 50px;
    font-size: 14px;
    float: left;
  }
}
</style>